(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"]) return;
  try {
    
  (() => {
    const bar = document.querySelector('[data-announcement-bar]');
    if (!bar || bar.dataset.initialized === 'true') return;
    bar.dataset.initialized = 'true';
    const rate = Number(window.Shopify?.currency?.rate) || 1;
    const formatMoney = (cents) => {
      if (window.Shopify?.formatMoney) return window.Shopify.formatMoney(cents, bar.dataset.moneyFormat);
      try {
        return new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency: bar.dataset.currency || 'USD' }).format(cents / 100);
      } catch (error) {
        return `$${(cents / 100).toFixed(2)}`;
      }
    };
    const freeShippingAmount = formatMoney(Math.round(3000 * rate));
    const discountAmount = formatMoney(Math.round(6000 * rate));
    bar.querySelector('[data-announcement-free]').textContent = bar.dataset.freeShippingTemplate.replace('__AMOUNT__', freeShippingAmount);
    bar.querySelector('[data-announcement-discount]').textContent = bar.dataset.discountTemplate.replace('__AMOUNT__', discountAmount);
    const track = bar.querySelector('[data-announcement-track]');
    let discountActive = false;
    window.setInterval(() => {
      discountActive = !discountActive;
      track.dataset.activeMessage = discountActive ? 'discount' : 'shipping';
    }, 4500);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart-drawer"]) return;
  try {
    
  (() => {
    if (window.BathpostsCart) return;
    const PRICING = {
      freeShippingUsd: 3000,
      discountUsd: 6000,
      shippingUsd: 699,
      highShippingUsd: 999,
      discountPercent: 10,
      highShippingCountries: ['MX', 'NO', 'CH']
    };
    const drawer = () => document.querySelector('[data-cart-drawer]');
    const currencyRate = () => {
      const rate = Number(window.Shopify?.currency?.rate);
      return Number.isFinite(rate) && rate > 0 ? rate : 1;
    };
    const convertUsd = (cents) => Math.round(cents * currencyRate());
    const formatMoney = (cents) => {
      const root = drawer();
      if (window.Shopify?.formatMoney) return window.Shopify.formatMoney(cents, root?.dataset.moneyFormat);
      const currency = root?.dataset.currency || 'USD';
      try { return new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency }).format(cents / 100); }
      catch (error) { return `$${(cents / 100).toFixed(2)}`; }
    };
    const copy = (key, amount) => {
      const template = drawer()?.dataset[key] || '';
      return amount === undefined ? template : template.replace('__AMOUNT__', formatMoney(amount));
    };
    const hydratePricing = () => {
      const root = drawer();
      if (!root) return;
      const freeTarget = convertUsd(PRICING.freeShippingUsd);
      const discountTarget = convertUsd(PRICING.discountUsd);
      const country = root.dataset.country;
      const highShippingCountry = PRICING.highShippingCountries.includes(country);
      const shippingPrice = convertUsd(highShippingCountry ? PRICING.highShippingUsd : PRICING.shippingUsd);

      document.querySelectorAll('[data-cart-rewards]').forEach((rewards) => {
        const subtotal = Number(rewards.dataset.subtotal || 0);
        const freeUnlocked = subtotal >= freeTarget;
        const discountUnlocked = subtotal >= discountTarget;
        const message = rewards.querySelector('[data-cart-reward-message]');
        if (message) {
          if (discountUnlocked) message.textContent = copy('discountUnlocked');
          else if (freeUnlocked) message.textContent = copy('freeShippingUnlocked');
          else message.textContent = copy('freeShippingRemaining', freeTarget - subtotal);
        }
        const progress = rewards.querySelector('[data-cart-reward-progress]');
        if (progress) {
          progress.max = discountTarget;
          progress.value = Math.min(subtotal, discountTarget);
        }
        const freeLabel = rewards.querySelector('[data-cart-free-shipping-label]');
        const discountLabel = rewards.querySelector('[data-cart-discount-label]');
        if (freeLabel) freeLabel.textContent = copy('freeShippingLabel', freeTarget);
        if (discountLabel) discountLabel.textContent = copy('discountLabel', discountTarget);
        rewards.querySelector('[data-cart-free-marker]')?.classList.toggle('is-unlocked', freeUnlocked);
        rewards.querySelector('[data-cart-discount-marker]')?.classList.toggle('is-unlocked', discountUnlocked);
      });

      document.querySelectorAll('[data-cart-pricing]').forEach((pricing) => {
        const subtotal = Number(pricing.dataset.subtotal || 0);
        const actualTotal = Number(pricing.dataset.actualTotal || subtotal);
        const totalDiscount = Number(pricing.dataset.totalDiscount || 0);
        const freeUnlocked = subtotal >= freeTarget;
        const discountUnlocked = subtotal >= discountTarget;
        const discountedSubtotal = discountUnlocked
          ? (totalDiscount > 0 ? actualTotal : Math.round(subtotal * (100 - PRICING.discountPercent) / 100))
          : actualTotal;
        const discountAmount = Math.max(0, subtotal - discountedSubtotal);
        const shipping = freeUnlocked ? 0 : shippingPrice;
        const total = discountedSubtotal + shipping;
        pricing.querySelector('[data-cart-subtotal]').textContent = formatMoney(subtotal);
        pricing.querySelector('[data-cart-shipping-amount]').textContent = freeUnlocked ? copy('freeLabel') : formatMoney(shipping);
        pricing.querySelector('[data-cart-total]').textContent = formatMoney(total);
        pricing.querySelector('[data-cart-subtotal-row]').hidden = freeUnlocked;
        pricing.querySelector('[data-cart-shipping-row]').hidden = freeUnlocked;
        const discountRow = pricing.querySelector('[data-cart-discount-row]');
        discountRow.hidden = !discountUnlocked;
        if (discountUnlocked) pricing.querySelector('[data-cart-discount-amount]').textContent = `−${formatMoney(discountAmount)}`;
        const originalTotal = pricing.querySelector('[data-cart-original-total]');
        originalTotal.hidden = !discountUnlocked;
        if (discountUnlocked) originalTotal.textContent = formatMoney(subtotal);
        pricing.querySelector('[data-cart-free-shipping]').hidden = !freeUnlocked;
      });
    };
    const open = () => {
      hydratePricing();
      drawer()?.querySelector('dialog')?.showModal();
    };
    const updateCount = (count) => {
      document.querySelectorAll('[data-cart-count]').forEach((badge) => {
        badge.textContent = count;
        badge.hidden = count === 0;
      });
    };
    const replace = (html, openAfter = true) => {
      const current = drawer();
      if (!current || !html) return;
      current.outerHTML = html;
      hydratePricing();
      if (openAfter) open();
    };
    const change = async (line, quantity) => {
      const endpoint = drawer()?.dataset.cartChangeUrl;
      const response = await fetch(endpoint, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ line, quantity, sections: 'cart-drawer', sections_url: window.location.pathname })
      });
      const data = await response.json();
      if (!response.ok) throw new Error(data.description || data.message);
      replace(data.sections['cart-drawer']);
      updateCount(data.item_count);
    };
    document.addEventListener('click', async (event) => {
      if (event.target.closest('[data-cart-open]')) { event.preventDefault(); open(); return; }
      if (event.target.closest('[data-cart-close]')) { drawer()?.querySelector('dialog')?.close(); return; }
      const control = event.target.closest('[data-cart-change]');
      if (control) {
        control.disabled = true;
        try { await change(Number(control.dataset.line), Number(control.dataset.quantity)); }
        catch (error) { control.disabled = false; }
      }
    });
    document.addEventListener('submit', async (event) => {
      const form = event.target.closest('[data-product-form]');
      if (!form) return;
      event.preventDefault();
      const submit = form.querySelector('[data-add-to-cart]');
      const status = form.querySelector('[data-product-status]');
      const productRoot = form.closest('[data-product-root]');
      const selectedVariantId = productRoot?.dataset.selectedVariantId || form.querySelector('[data-variant-id]').value;
      const items = [{ id: Number(selectedVariantId), quantity: Number(form.elements.quantity.value || 1) }];
      const hangerToggle = form.querySelector('[data-hanger-toggle]');
      const hangerId = form.querySelector('[data-hanger-id]');
      if (hangerToggle?.checked && hangerId?.value) items.push({ id: Number(hangerId.value), quantity: 1 });
      submit.disabled = true;
      submit.setAttribute('aria-busy', 'true');
      try {
        const response = await fetch(drawer().dataset.cartAddUrl, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items, sections: 'cart-drawer', sections_url: window.location.pathname })
        });
        const data = await response.json();
        if (!response.ok) throw new Error(data.description || data.message);
        replace(data.sections['cart-drawer']);
        const cartResponse = await fetch(window.Shopify.routes.root + 'cart.js');
        const cart = await cartResponse.json();
        updateCount(cart.item_count);
        if (status) status.textContent = '';
      } catch (error) {
        if (status) status.textContent = error.message;
      } finally {
        submit.disabled = false;
        submit.removeAttribute('aria-busy');
      }
    });
    document.addEventListener('DOMContentLoaded', hydratePricing);
    hydratePricing();
    window.BathpostsCart = { open, change, hydratePricing };
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection"]) return;
  try {
    
  (() => {
    const featuredId = new URL(window.location.href).searchParams.get('featured');
    if (!featuredId || !/^\d+$/.test(featuredId)) return;

    document.querySelectorAll('[data-collection-product-grid]').forEach(async (grid) => {
      const selector = `[data-product-id="${featuredId}"]`;
      const placeFirst = (card) => {
        grid.querySelectorAll(selector).forEach((duplicate) => {
          if (duplicate !== card) duplicate.remove();
        });
        grid.prepend(card);
      };

      const loadedCard = grid.querySelector(selector);
      if (loadedCard) {
        placeFirst(loadedCard);
        return;
      }

      const sectionId = grid.dataset.sectionId;
      const currentPage = Number.parseInt(grid.dataset.currentPage || '1', 10);
      const totalPages = Number.parseInt(grid.dataset.totalPages || '1', 10);
      if (!sectionId || totalPages < 2) return;

      for (let page = 1; page <= totalPages; page += 1) {
        if (page === currentPage) continue;
        const url = new URL(window.location.href);
        url.searchParams.delete('featured');
        url.searchParams.set('page', String(page));
        url.searchParams.set('sections', sectionId);

        try {
          const response = await fetch(url.toString(), {
            headers: { 'X-Requested-With': 'XMLHttpRequest' }
          });
          if (!response.ok) continue;
          const sections = await response.json();
          const html = sections[sectionId];
          if (!html) continue;
          const documentFragment = new DOMParser().parseFromString(html, 'text/html');
          const featuredCard = documentFragment.querySelector(selector);
          if (featuredCard) {
            placeFirst(featuredCard);
            break;
          }
        } catch (error) {
          continue;
        }
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  document.addEventListener('change', (event) => {
    if (event.target.matches('[data-localization-selector]')) event.target.form.submit();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
